import axios from 'axios'
import { AxiosRequestConfig } from './AxiosRequestConfig'
import UsersService from './UsersService'

const apiClientThinkHome = axios.create(AxiosRequestConfig)

let isNode = typeof module !== 'undefined'

apiClientThinkHome.interceptors.request.use(
  function(config) {
    let token = ''
    //console.log('DataSourceService', localStorage['auth._token.local'])

    if (!isNode || (localStorage && localStorage.apiCredentials)) {
      if (localStorage && localStorage.apiCredentials) {
        token = localStorage.apiCredentials
      }
    }
    if (token !== '' && typeof token !== 'undefined') {
      config.headers.common['Authorization'] = `Bearer ${token}`
    }
    return config
  },
  function(error) {
    // Do something with request error
    return Promise.reject(error)
  }
)

// Add a response interceptor
apiClientThinkHome.interceptors.response.use(
  response => {
    return response
  },
  async error => {
    const originalConfig = error.config
    if (error.response) {
      if (
        error.config.url !== '/users/refresh-token' &&
        error.response.status === 401 &&
        !originalConfig._retry
      ) {
        originalConfig._retry = true
        await UsersService.refreshToken()
        return apiClientThinkHome(originalConfig)
      }

      // if (error.response.status === ANOTHER_STATUS_CODE) {
      // 	// Do something
      // 	return Promise.reject(error.response.data);
      // }
    }

    return Promise.reject(error)
  }
)

export default {
  apiClientThinkHome
}
